import * as tslib_1 from "tslib";
import { Injector, OnChanges, OnDestroy, SimpleChanges, ViewContainerRef, } from '@angular/core';
import { BaseChart } from '@components/ui-chart/base-chart';
import isObject from 'lodash-es/isObject';
import * as numbro from 'numbro';
import { takeUntil } from 'rxjs/operators';
import { PIE_CHART_OPTIONS, PIE_RADIUS, } from './ui-pie-chart.constants';
var NUMBRO_OPTIONS = {
    average: true,
    mantissa: 1,
    trimMantissa: true,
};
var UiPieChartComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UiPieChartComponent, _super);
    function UiPieChartComponent(injector, _viewContainerRef) {
        var _this = _super.call(this, injector) || this;
        _this._viewContainerRef = _viewContainerRef;
        _this.doughnutRadiusPercentage = 0;
        _this.onSegmentClick = function (params) {
            var clickedData = _this.data[params.dataIndex];
            if (isObject(clickedData)) {
                _this.segmentClick.emit(clickedData.key);
            }
        };
        _this._getTooltipText = function (params) {
            if (_this.tooltipFormatter) {
                return _this.tooltipFormatter(params);
            }
            var tooltipName = _this.data[params.dataIndex].tooltipName;
            var seriesName = tooltipName ? tooltipName : params.name;
            return "\n            <div class=\"chart-tooltip-container\">\n                <div class=\"tooltip-title\">\n                    <span class=\"tooltip-marker\">" + params.marker + "</span>\n                    <strong>" + params.value + "</strong>\n                </div>\n                <div class=\"tooltip-subtitle\">\n                    " + seriesName + "\n                </div>\n            </div>";
        };
        _this._extendOptions(PIE_CHART_OPTIONS);
        _this._colorProvider.changes$
            .pipe(takeUntil(_this._destroyed$))
            .subscribe(function () {
            _this._extendOptions({
                title: {
                    textStyle: {
                        color: _this._colorProvider.textColor,
                    },
                },
            });
        });
        _this.chartOptions.tooltip.formatter = _this._getTooltipText;
        _this._legendVisibilityChange$
            .pipe(takeUntil(_this._destroyed$))
            .subscribe(function () {
            _this._updateSum();
        });
        return _this;
    }
    UiPieChartComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        _super.prototype.ngOnChanges.call(this, changes);
        if (this.doughnutRadiusPercentage != null &&
            changes.doughnutRadiusPercentage) {
            this.chartOptions.series[0].radius[0] = this.doughnutRadiusPercentage / 100 * parseInt(PIE_RADIUS, 10) + "%";
        }
        if (this.data &&
            (changes.data ||
                changes.legend ||
                changes.colors)) {
            // TODO: extract this into a NumbroFormatterModule :)
            this.chartOptions.series[0].label.normal.formatter =
                function (item) { return numbro(item.value).format(tslib_1.__assign({}, NUMBRO_OPTIONS, { totalLength: 2 })); };
            this.chartOptions.series[0].data = [];
            this.chartOptions.legend.data = [];
            var sum_1 = this.data.reduce(function (acc, current) { return (typeof current === 'number' ?
                acc + current :
                acc + current.value); }, 0); // ng test throws lint error
            this.data.forEach(function (data, index) {
                var value;
                if (typeof data === 'number') {
                    value = data;
                }
                else {
                    value = data.value;
                }
                var pieData = {
                    value: value,
                    name: (_this.legend || [])[index] || '',
                };
                if (!pieData.value) {
                    pieData.label = {
                        show: false,
                    };
                }
                else if (pieData.value / sum_1 < .2 &&
                    (pieData.value / sum_1 < .15 && pieData.value > 9)) {
                    pieData.label = Object.assign(pieData.label || {}, {
                        position: 'outside',
                    });
                }
                if (_this.colors) {
                    pieData.itemStyle = {
                        color: _this.colors[index] || null,
                    };
                }
                _this.chartOptions.series[0].data.push(pieData);
                if (_this.legend) {
                    _this.chartOptions.legend.data.push({
                        name: _this.legend[index] || '',
                        icon: 'circle',
                    });
                }
            });
        }
        if (this.data &&
            (changes.data ||
                changes.legend ||
                changes.doughnutRadiusPercentage)) {
            if (+this.doughnutRadiusPercentage > 0) {
                this._updateSum();
            }
            else {
                this.chartOptions.title.text = '';
            }
        }
    };
    UiPieChartComponent.prototype._onResize = function () {
        if (this._chart &&
            this.chartOptions.title &&
            this.chartOptions.title.text) {
            var smallerSide = Math.min(this._viewContainerRef.element.nativeElement.offsetWidth, this._viewContainerRef.element.nativeElement.offsetHeight);
            var maxTextWidth = parseInt(PIE_RADIUS, 10) * this.doughnutRadiusPercentage / 10000 * smallerSide;
            var fontSize = maxTextWidth / Math.max(4, this.chartOptions.title.text.length); // Formula deduced empirically.
            this.chartOptions.title.textStyle.fontSize = fontSize;
            this.chartOptions.title.padding[0] = -fontSize / 2;
            this.update();
        }
    };
    UiPieChartComponent.prototype._updateSum = function () {
        var _this = this;
        var pieSum = 0;
        this.data.forEach(function (data, index) {
            if (!_this.legend ||
                !_this.legend[index]) {
                return;
            }
            var legendName = _this.legend[index];
            if (!_this.legendItemsVisibility ||
                !_this.legendItemsVisibility[legendName]) {
                return;
            }
            var value = (data.value != null ?
                data.value :
                data);
            pieSum += value;
        });
        this.chartOptions.title.text = numbro(pieSum).format(NUMBRO_OPTIONS);
        this._onResize();
    };
    return UiPieChartComponent;
}(BaseChart));
export { UiPieChartComponent };
